import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

const defaults = {
  type: 'debug',
  category: 'status-change'
};

const SentryUserStatus = ({ children }: { children: React.ReactElement }) => {
  useEffect(() => {
    const onFocusChangeHandler = (status: boolean) => () => {
      Sentry.addBreadcrumb({
        ...defaults,
        message: 'User focus status changed',
        data: {
          isFocused: status
        }
      });
    };

    const onOnlineChangeHandler = (status: boolean) => () => {
      Sentry.addBreadcrumb({
        ...defaults,
        message: 'User online status changed',
        data: {
          isOnline: status
        }
      });
    };

    const onBackgroundChangeHandler = (status: boolean) => () => {
      Sentry.addBreadcrumb({
        ...defaults,
        message: 'User background status changed',
        data: {
          isAppInBackground: status
        }
      });
    };

    const onFocus = onFocusChangeHandler(true);
    const onBlur = onFocusChangeHandler(false);
    const onOnline = onOnlineChangeHandler(true);
    const onOffline = onOnlineChangeHandler(false);
    const onPause = onBackgroundChangeHandler(true);
    const onResume = onBackgroundChangeHandler(false);

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    window.addEventListener('pause', onPause);
    window.addEventListener('resume', onResume);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('pause', onPause);
      window.removeEventListener('resume', onResume);
    };
  }, []);

  return children;
};

export default SentryUserStatus;
